import {faker}  from "@faker-js/faker";
import { getAccounts } from "../helpers/get-accounts";
import defaultValues from "../scenarios/default";
import { getOrgApp } from "../helpers/get-orgApp";

// var tags = [
//   "HR-Prod-BackEnd-Server2",
//   "HR-Prod-DB-Server1",
//   "Sales-FrontEnd-Test-Server1",
//   "Sales-FrontEnd-Prod-Server1",
//   "Sales-FrontEnd-Prod-Server2"
// ];

var states = ["running", "stopped", "pending"];

var regionCodes = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ap-south-1",
];

var os = defaultValues().os;

var resourceType = [
  "CloudTrail-Log",
  "EBS-EventRule",
  "EC2InstanceState-EventRule",
  "EC2TagChange-EventRule",
  "RDS-Instance-EventRule",
  "Snapshot-EventRule",
];

export const allCoudWatchEventRules = async () => {
  let coudWatchEventRules = [];
  let accounts = await getAccounts();
  let orgAppDetails = await getOrgApp();
  for (var i = 0; i < 15; i++) {
    let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
    let selectedDept = faker.helpers.arrayElement(selectedOrg.depts);
    let selectedDeptApp = faker.helpers.arrayElement(selectedDept.deptApps);
    let regionCode = faker.helpers.arrayElement(regionCodes);
    let accountNumber = faker.helpers.arrayElement(accounts);
    coudWatchEventRules.push({
      Tags: [],
      InstanceState: faker.helpers.arrayElement(states),
      AccountNumber: accountNumber,
      CustomerId: faker.number.int(),
      RegionCode: regionCode,
      IsManaged: faker.random.boolean(),
      UpdatedAt: faker.date.past(),
      OperatingSystem: faker.helpers.arrayElement(os),
      ResourceId:
        "arn:aws:events:" +
        regionCode +
        ":" +
        accountNumber +
        ":rule/MontyCloud-" +
        faker.helpers.arrayElement(resourceType),
      ResourceName:
        "MontyCloud-" +
        faker.helpers.arrayElement(resourceType) +
        "-" +
        faker.random.alphaNumeric(8),
      OrganizationId: selectedOrg.orgId,
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      DepartmentId: selectedDept.deptId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
    });
  }
  return coudWatchEventRules;
};
